import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: {},
    isLogged: false,
    modalID: null,
    lsList: [],
    loadData: false,
    accountNumber: null,
    everokToken: null
  },
  mutations: {
    setUser(state, user) {
      state.currentUser = user;
    },
    setModalID(state, id) {
      state.modalID = id;
    },
    setUserStatus(state, value) {
      state.isLogged = value;
    },
    setLsList(state, value) {
      state.lsList = value;
    },
    
    setGetData(state, value) {
      state.loadData = value;
    },
    setAccountNumber(state, value) {
      state.accountNumber = value;
    },
    setEverokToken(state, value) {
      state.everokToken = value;
    }
  },
  actions: {},
  getters: {
    getUser: state => state.currentUser,
    getModal: state => state.modalID,
    getUserStatus: state => state.isLogged,
    getLsList: state => state.lsList,
    getData: state => state.loadData
  }
});
